// extracted by mini-css-extract-plugin
export default {"placeholder":"SuggestedPerspectives_placeholder__iBGjq","wrapper":"SuggestedPerspectives_wrapper__rlA3v","loaderWrapper":"SuggestedPerspectives_loaderWrapper__bijL2"};